/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
/*!**************************************!*\
  !*** ./src/assets/js/early-timer.js ***!
  \**************************************/
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var EarlyTimer = /*#__PURE__*/function (_HTMLElement) {
  _inherits(EarlyTimer, _HTMLElement);

  var _super = _createSuper(EarlyTimer);

  function EarlyTimer() {
    var _this;

    _classCallCheck(this, EarlyTimer);

    _this = _super.call(this);
    _this.sectionId = _this.dataset.sectionId;
    _this.parentSection = document.querySelector("#shopify-section-".concat(_this.sectionId));
    _this.days = _this.querySelector('.days');
    _this.hours = _this.querySelector('.hours');
    _this.minutes = _this.querySelector('.minutes');
    _this.seconds = _this.querySelector('.seconds');
    _this.endDate = _this.dataset.endDate; // Expecting format dd/mm/yyyy

    _this.endTime = _this.dataset.endTime; // Expecting format HH:MM AM/PM

    _this.timeZone = _this.dataset.timeZone; // E.g., "UTC+0"

    _this.timeinterval;
    return _this;
  }

  _createClass(EarlyTimer, [{
    key: "connectedCallback",
    value: function connectedCallback() {
      this.initialize();
    }
  }, {
    key: "parseCustomDateTime",
    value: function parseCustomDateTime(date, time, timeZone) {
      var parts = date.split('/');
      var formattedDate = "".concat(parts[1], "/").concat(parts[0], "/").concat(parts[2], " ").concat(time, " ").concat(timeZone);
      return new Date(formattedDate);
    }
  }, {
    key: "getTimeRemaining",
    value: function getTimeRemaining(endtime) {
      var t = Date.parse(endtime) - Date.parse(new Date());
      var seconds = Math.floor(t / 1000 % 60);
      var minutes = Math.floor(t / 1000 / 60 % 60);
      var hours = Math.floor(t / (1000 * 60 * 60) % 24);
      var days = Math.floor(t / (1000 * 60 * 60 * 24));
      return {
        'total': t,
        'days': days,
        'hours': hours,
        'minutes': minutes,
        'seconds': seconds
      };
    }
  }, {
    key: "updateClock",
    value: function updateClock() {
      var t = this.getTimeRemaining(this.deadline);
      this.days.innerHTML = t.days;
      this.hours.innerHTML = ('0' + t.hours).slice(-2);
      this.minutes.innerHTML = ('0' + t.minutes).slice(-2);
      this.seconds.innerHTML = ('0' + t.seconds).slice(-2);

      if (t.total <= 0) {
        clearInterval(this.timeinterval);
        this.parentSection.classList.add('hidden');
      } else {
        this.parentSection.classList.remove('hidden');
      }
    }
  }, {
    key: "initialize",
    value: function initialize() {
      var _this2 = this;

      this.deadline = this.parseCustomDateTime(this.endDate, this.endTime, this.timeZone);
      this.updateClock();
      this.timeinterval = setInterval(function () {
        return _this2.updateClock();
      }, 1000);
    }
  }]);

  return EarlyTimer;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));

if (!customElements.get('early-timer')) {
  customElements.define('early-timer', EarlyTimer);
}
/******/ })()
;